import { RandomItem } from "../../interfaces/IContentModel";
import { PopupModel } from "../../interfaces/IContentModel";
import BaseScene from "../../scenes/BaseScene";
import { number } from "../utils/Utils";
import SpongePlugin from "./SpongePlugin";

/** https://phasergames.com/phaser-3-input-text-form-ui-part-1/ <- HTML input box would be nice.
 *
 * @category plugins
 * @export
 * @class HTMLPlugin
 * @extends {Phaser.Plugins.BasePlugin}
 */
export default class HTMLPlugin extends Phaser.Plugins.BasePlugin {
  /**
   * HTML events to listen to: "popup"|"input"
   *
   * @type {Phaser.Events.EventEmitter}
   * @memberof HTMLPlugin
   */
  public events: Phaser.Events.EventEmitter = new Phaser.Events.EventEmitter();

  private _sponge!: SpongePlugin;
  currentPopupModel: PopupModel;
  currentRandomItem: RandomItem;
  stopCloseAnimation: boolean;
  // private scene: BaseScene;

  /**
   * @constructor Creates an instance of the HTML plugin (that handles any non phaser HTML based content / functionallity).
   * @param {Phaser.Plugins.PluginManager} pluginManager
   * @memberof GameData
   */
  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    console.log("HTML::constructor", this._sponge);
  }

  lastLaunchedPopup: string = "";

  buttonLabelOverride: string = "";

  /**
   * launch popup of ID, first will attempt to call the popup event on this class,
   * if no listeners present then a simple HTML popup is created and used.
   *
   * @param {string} id
   * @param {() => void} callback
   * @memberof HTMLPlugin
   */
  public launchPopup(
    id: string,
    callback: () => void,
    buttonLabelOverride?: string
  ): void {
    // get the popup and prepare the model for use;

    this.buttonLabelOverride = buttonLabelOverride;

    console.log("HTMLPlugin::LaunchPopup", id, callback);

    this.assertSponge();

    const popupModel: PopupModel | undefined = this._sponge.data.getPopup(id);
    //const RandomItem: RandomItem | undefined = this._sponge.data.RandomItem;
    if (popupModel === undefined) {
      console.warn(`popup with id ${id} cannot be found, skipping`);
      callback();
      return;
    }

    this.currentPopupModel = popupModel;

    //this.currentRandomItem = RandomItem;

    this.lastLaunchedPopup = id;

    console.log("Loaded PopupModel", popupModel);

    this.stopCloseAnimation = false;

    if (this._sponge.data.model.save.seenQuestionFeedback.indexOf(id) === -1) {
      this._sponge.data.save.seenQuestionFeedback.push(id);
      this._sponge.tracking.save();
      console.warn(
        "!!!!!added feedback popup " +
          id +
          " to seenQuestionFeedback saveData!!!!"
      );
    } else {
      console.warn(
        "!!!!!feedback popup " + id + "  in seenQuestionFeedback saveData!!!!"
      );
      this.stopCloseAnimation = true;
    }

    if (this.events.listenerCount("popup") > 0) {
      this.events.emit("popup", {
        model: popupModel,
        onComplete: callback,
      });
      return;
    } else {
      //default to HTML popup
      this.showHTMLPopup(popupModel, callback);
      return;
    }
  }

  /**
   * shoe basic popup that will fit the the container of the phaser canvas
   * callback is what gets fire when the popup is dismissed.
   *
   * @private
   * @param {PopupModel} model
   * @param {() => void} callback
   * @memberof HTMLPlugin
   */
  // private showBasicPopup(scene: BaseScene, model: PopupModel, callback: () => void): void {
  //   // pause game?
  //   scene.pause();
  //   new Popup(scene, model, () => {
  //     scene.resume();
  //     callback()
  //   });

  // }

  /**
   * waits until the dom node is populated before adding class to give nice transition in
   *
   * @private
   * @memberof HTMLPlugin
   */
  private waitAndAnimateInPopup() {
    if (this.popupContainer.children.length === 0) {
      window.requestAnimationFrame(this.waitAndAnimateInPopup.bind(this));
    } else {
      this.popupContainer.classList.add("show");
    }
  }

  public showHTMLPopup(model: PopupModel, callback: () => void): void {
    // if we haven't initilised our basic popup container lets set that up first.
    if (this.popupContainer === undefined) {
      this.setupPopupContainer();
    }

    // disable input
    this.game.input.enabled = false;

    // popuplate markup
    this.popupContainer.innerHTML = this.basicPopupHTML(model);

    if (model._classes === "intro") {
      this.popupContainer.classList.add("transparent");
    }

    if (model._classes && model._classes.indexOf("blackout") !== -1) {
      this.popupContainer.classList.add("blackout");
    }

    setTimeout(() => {
      this.waitAndAnimateInPopup();
    }, 50);

    // register on click of close button

    const button = document.getElementById("popup-close-button");
    if (!button) {
      console.warn(
        "cannot find button to add click listener to of id `popup-close-button`"
      );
      return;
    }

    // button.addEventListener("pointerover", () => {
    //   for (const scene of this.game.scene.scenes) {
    //     if (scene._key !== "Boot" && scene.preloadProgress === 1) {
    //       if (this.currentPopupModel._closeVoiceOver) {
    //         (scene as BaseScene).sponge.startVO(
    //           this.currentPopupModel._closeVoiceOver,
    //           scene
    //         );
    //       } else if (this.currentRandomItem._closeVoiceOver) {
    //         (scene as BaseScene).sponge.startVO(
    //           this.currentRandomItem._closeVoiceOver,
    //           scene
    //         );
    //       } else {
    //         (scene as BaseScene).sponge.stopVO();
    //       }

    //       break;
    //     }
    //   }
    // });

    button.addEventListener("click", () => {
      //if alredady resumed ignore.
      if (this.game.input.enabled) {
        return;
      }

      // re-enable game input - call the callback supplied and clear the popup content.
      this.game.input.enabled = true;

      //animate out popup
      this.popupContainer.classList.remove("show");

      // Stop VO
      this._sponge.stopVO();

      //remove popup after out out animation
      setTimeout(() => {
        this.clearPopup();
        callback();
      }, 400);
    });

    //custom check for feedback buttons - stop animation if

    if (this.stopCloseAnimation) {
      button.classList.add("no-close-anim");
    }

    //set first page to active?
    this.pages = this.popupContainer.getElementsByClassName("page");

    //listen for next previous buttons
    const nextButton = document.getElementById("next-popup-page");
    if (nextButton) {
      nextButton.addEventListener("click", () => {
        this.nextPage();
      });
    }

    //listen for previous previous buttons
    const previousButton = document.getElementById("previous-popup-page");
    if (previousButton) {
      previousButton.addEventListener("click", () => {
        this.previousPage();
      });

      // hide previous button if first popup in paged popup?
      previousButton.classList.add("hidden");
    }

    //for mobile devices when extra info appears from glossary
    const glossaryWords = document.getElementsByClassName("glossary-word");
    const glossaryClosebuttons = document.getElementsByClassName(
      "description-close"
    );
    const infoBoxes = document.getElementsByClassName("description");
    if (glossaryWords.length > 0) {
      for (let i: number = 0; i < glossaryWords.length; i++) {
        glossaryWords[i].addEventListener("click", (event) => {
          event.stopPropagation();
          const vo = glossaryWords[i].getAttribute("data-vo");

          console.log(vo);

          if (vo && vo !== "") {
            for (const scene of this.game.scene.scenes) {
              if (
                scene._key !== "Boot" &&
                scene.preloadProgress === 1 &&
                scene.scene.isActive()
              ) {
                (scene as BaseScene).sponge.startVO(vo, scene);
                break;
              }
            }
          }
          
          // console.warn("CLICKED GLOSSARY WORD");
          infoBoxes[i].classList.add("show");
          glossaryClosebuttons[i].classList.add("show");
        });

        glossaryClosebuttons[i].addEventListener("click", (event) => {
          event.stopPropagation();
          this._sponge.stopVO(); // ?
          // console.warn("CLICKED GLOSSARY close");
          infoBoxes[i].classList.remove("show");
          glossaryClosebuttons[i].classList.remove("show");
        });
      }
    }

    this.loadPage(0);
  }

  currentPage: number = -1;
  pages: any;

  nextPage() {
    this.loadPage(Math.min(this.pages.length - 1, this.currentPage + 1));
  }

  previousPage() {
    this.loadPage(Math.max(0, this.currentPage - 1));
  }

  loadPage(number: number) {
    console.log("Load Page", this.currentPopupModel);

    // if (this.scene)
    //   this.scene.sound.play("click", { volume: 0.3, });
    document.getElementById("next-popup-page");

    if (this.currentPage === number) {
      return;
    }

    this.currentPage = number;

    if (this.buttonLabelOverride) {
      document.getElementById(
        "popup-close-button"
      ).innerHTML = this.buttonLabelOverride;
    } else if (this.currentPopupModel.pages[this.currentPage].closeLabel) {
      document.getElementById(
        "popup-close-button"
      ).innerHTML = this.currentPopupModel.pages[this.currentPage].closeLabel;
    } else {
      document.getElementById(
        "popup-close-button"
      ).innerHTML = this.currentPopupModel.closeLabel;
    }

    if (this.currentPage > 0) {
      document.getElementById("previous-popup-page").classList.remove("hidden");
    } else {
      document.getElementById("previous-popup-page").classList.add("hidden");
    }

    if (this.currentPage === this.pages.length - 1) {
      document.getElementById("next-popup-page").classList.add("hidden");
    } else {
      document.getElementById("next-popup-page").classList.remove("hidden");
    }

    this.events.emit("loadPage", number, this.lastLaunchedPopup);

    // let currentScene: BaseScene;

    for (let scene of this.game.scene.scenes) {
      if (
        scene._key !== "Boot" &&
        scene.preloadProgress === 1 &&
        scene.scene.isActive()
      ) {
        if (this.currentPopupModel.pages[this.currentPage]._voiceOver) {
          (scene as BaseScene).sponge.startVO(
            this.currentPopupModel.pages[this.currentPage]._voiceOver,
            scene
          );
        } else {
          (scene as BaseScene).sponge.stopVO();
        }

        break;
      }
    }

    for (let i = 0; i < this.pages.length; i++) {
      if (i === number) {
        this.pages[i].classList.add("active");
      } else {
        this.pages[i].classList.remove("active");
      }
    }

    //update navigation and buttons.
    const pageNumberElement = document.getElementById(
      "current-popup-page-number"
    );
    if (pageNumberElement) {
      pageNumberElement.innerHTML = `${this.currentPage + 1}/${
        this.pages.length
      }`;
    }

    const closeButton = document.getElementById("popup-close-button");
    if (closeButton) {
      if (this.currentPage === this.pages.length - 1) {
        closeButton.classList.add("show");
      } else {
        closeButton.classList.remove("show");
      }

      // set close button text if persistent close
    }
  }

  /**
   * clear the content from a popup
   *
   * @private
   * @memberof HTMLPlugin
   */
  private clearPopup(): void {
    this.currentPage = -1;
    this.popupContainer.innerHTML = "";
    this.popupContainer.parentNode.removeChild(this.popupContainer);
    this.popupContainer = undefined;
  }

  public updateCloseLabel(newLabel: string): void {
    const closeButton = document.getElementById("popup-close-button");
    closeButton.innerHTML = newLabel;
  }

  public makePersistantClose(): void {
    this.popupContainer.classList.add("persistent-close");
  }

  /**
   * our HTMLElement that we load the HTML popups into (Development or standalone)
   *
   * @private
   * @type {HTMLElement}
   * @memberof HTMLPlugin
   */
  private popupContainer!: HTMLElement;
  private htmlContainer!: HTMLElement;

  /**
   * set up a basic HTML popup container, hook up resize events
   *
   * @private
   * @memberof HTMLPlugin
   */
  private setupPopupContainer(): void {
    //get the html container
    this.htmlContainer = document.getElementById("html-container");

    // create element
    this.popupContainer = document.createElement("div");

    // assign id for styles
    this.popupContainer.id = "popup-container";

    // add to display list
    if (this.htmlContainer) {
      this.htmlContainer.appendChild(this.popupContainer);
    } else {
      console.warn("cannot get parent element of game canvas");
      return;
    }
    // set initial style
    this.popupContainer.setAttribute(
      "style",
      `position:absolute; width:${this.game.canvas.style.width}; height:${this.game.canvas.style.height};`
    );

    // on resize of the game (from scale manager) lets resize out popup container.
    this.game.scale.on(
      "resize",
      (gameSize: any, baseSize: any, displaySize: any) => {
        //using resize.FIT as the algorithm, lets use the besst fit & no expand to work out the zoom level.
        const maxXZoom = displaySize.width / gameSize.width;
        const maxYZoom = displaySize.height / gameSize.height;

        const zoom = Math.min(1, Math.max(maxXZoom, maxYZoom));

        if (this.popupContainer) {
          this.popupContainer.setAttribute(
            "style",
            `transform:scale(${zoom}); width:${gameSize.width}px; height:${gameSize.height}px; margin-left: ${this.game.scale.canvasBounds.x}px; margin-top: ${this.game.scale.canvasBounds.y}px;`
          );
        }
      }
    );

    this.game.scale.refresh();
  }

  /**
   * make sure the sponge helper class is set.
   *
   * @private
   * @memberof HTMLPlugin
   */
  private assertSponge(): void {
    if (this._sponge === undefined) {
      this._sponge = this.pluginManager.get("sponge") as SpongePlugin;
    }
  }

  /**
   * format the HTLL of a simple popup to be displayed either in Phaser standalone or the development enviroment
   *
   * @param {PopupModel} popup
   * @returns {string}
   * @memberof HTMLPlugin
   */
  public basicPopupHTML(popup: PopupModel): string {
    return `
    <div class="popup ${popup._classes !== undefined ? popup._classes : ""}${
      popup.pages.length <= 1 ? " single" : ""
    }">
    
    <div class="popup-top-wrap">
    <button id="previous-popup-page"></button>
    <div class="popup-content">
    ${popup.pages
      .map(
        (page: any, i: number) => `
    <div class="page" data-page="${i}">
    ${page._image ? `<img class='image-top' src='${page._image}' /'>` : ``}
    <div class="body-wrap">
    ${
      page.body
        ? `<div class="body">
    ${page.title ? `<h1>${page.title}</h1>` : ``}
    ${page.body}</div>`
        : ``
    }
    </div>
    </div>
    `
      )
      .join(``)}
    </div>

      <button id="next-popup-page"></button>
    </div>
    <div class='popup-close-wrapper'>
    <button id='popup-close-button'>${popup.closeLabel}</button>
    </div>

    </div>

    </div>`;
  }
}
